<template>
  <v-dialog :value="true" persistent max-width="600px" min-width="360px">
    <div>
      <v-tabs show-arrows background-color="primary" icons-and-text dark grow>
        <v-tabs-slider color="primary darken-4"></v-tabs-slider>

        <v-tab>
          <v-icon large>mdi-account-outline</v-icon>
          <div class="caption py-1">Register</div>
        </v-tab>

        <v-tab-item>
          <v-card v-if="loading" class="px-4">
            <LoadingBar />
          </v-card>
          <div v-else-if="error !== false" class="error lighten-1">
            <p class="pa-5 text-center" v-html="error"></p>
          </div>
          <v-card class="px-4">
            <v-card-text>
              <v-form
                ref="copyToRegisterForm"
                v-model="valid"
                :disabled="error !== false"
                lazy-validation
                @submit.prevent="submit"
              >
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :disabled="error !== false"
                      name="first_name"
                      v-model="first_name"
                      :rules="rules.name"
                      label="First Name"
                      maxlength="200"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      name="last_name"
                      v-model="last_name"
                      :disabled="error !== false"
                      :rules="rules.name"
                      label="Last Name"
                      maxlength="200"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      name="business_name"
                      v-model="copyToRegistration.data.business_name"
                      :disabled="error !== false"
                      :rules="rules.business_name"
                      label="Business Name (optional)"
                      maxlength="200"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      name="username"
                      v-model="username"
                      :rules="rules.username"
                      label="username"
                      maxlength="200"
                      :disabled="error !== false"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      name="email"
                      v-model="email"
                      :rules="rules.email"
                      label="Email"
                      maxlength="200"
                      required
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-text-field
                      label="Password"
                      v-model="copyToRegistration.data.password"
                      :rules="rules.password"
                      :disabled="error !== false"
                      maxlength="100"
                      :type="showPassword ? 'text' : 'password'"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      ref="passwordConfirm"
                      label="Password (confirm)"
                      v-model="password_confirm"
                      :disabled="error !== false"
                      maxlength="100"
                      v-on:keyup.enter="submit"
                      :rules="rules.password_confirm"
                      :type="showConfirmPassword ? 'text' : 'password'"
                      :append-icon="
                        showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'
                      "
                      @click:append="showConfirmPassword = !showConfirmPassword"
                    ></v-text-field>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6" xsm="12"></v-col>
                  <v-spacer></v-spacer>
                  <v-col class="d-flex" cols="12" sm="3" xsm="12" align-end>
                    <v-btn
                      x-large
                      block
                      color="primary"
                      :disabled="!valid || buttonLoading || error !== false"
                      :loading="buttonLoading"
                      @click="submit"
                    >
                      <span v-if="!buttonLoading">Register</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import rules from "@/utils/rules";
import LoadingBar from "@/components/loaders/LoadingBar";

export default {
  name: "CopyToRegister",
  components: { LoadingBar },
  data() {
    return {
      loading: true,
      valid: false,
      buttonLoading: false,
      error: false,
      password_confirm: "",
      showPassword: false,
      showConfirmPassword: false,
      rules: {
        required: [rules.required],
        password: [rules.password],
        email: [rules.required, rules.email],
        password_confirm: [
          rules.required,
          v =>
            v === this.copyToRegistration.data.password ||
            "Passwords do not match"
        ],
        username: [rules.username],
        name: [
          rules.required,
          v =>
            /^[A-Za-z\s]+$/.test(v) ||
            "Name must contain only letters and spaces"
        ],
        business_name: [
          v =>
            !v ||
            /^[A-Za-z\s]+$/.test(v) ||
            "Name must contain only letters and spaces"
        ]
      }
    };
  },
  computed: {
    ...mapFields("auth", ["username"]),
    ...mapFields("auth", [
      "copyToRegistration.data.username",
      "copyToRegistration.data.email",
      "copyToRegistration.data.password",
      "copyToRegistration.data.first_name",
      "copyToRegistration.data.last_name",
      "copyToRegistration.data.business_name",
      "copyToRegistration.data.fax"
    ]),
    ...mapFields("auth", ["is_copy_to_register"]),
    ...mapState("auth", ["copyToRegistration"])
  },
  methods: {
    ...mapActions("auth", ["copyToFetch", "copyToRegister"]),
    submit() {
      if (!this.$refs.copyToRegisterForm.validate()) return false;
      this.buttonLoading = true;
      this.is_register = false;
      this.is_copy_to_register = true;

      this.copyToRegister(this.$route.params.token)
        .then(res => {
          this.buttonLoading = false;

          if (!res) {
            this.error = this.copyToRegistration.error;
          }
        })
        .catch(() => {
          this.buttonLoading = false;
        });
    },
    validate() {
      return this.$refs.copyToRegisterForm.validate();
    }
  },
  mounted() {
    this.copyToFetch(this.$route.params.token).then(res => {
      this.$refs.copyToRegisterForm.resetValidation();
      if (!res) {
        this.error = this.copyToRegistration.error;
      }
      // And we're always done loading
      this.loading = false;
    });
  },
  watch: {
    "copyToRegistration.data.password"() {
      this.$refs.passwordConfirm && this.$refs.passwordConfirm.validate();
    }
  }
};
</script>

<style scoped></style>
